export const handleMobileAppCarousel = () => {
  const parentNodeMobileAppCarousel =
    document.querySelector<HTMLElement>('.o-Carousel')?.parentNode

  const changeClassName = (id: number, className: string) => {
    const element = document.querySelector<HTMLElement>(`[data-img-id="${id}"]`)
    if (element) {
      element.className = className
    }
  }

  function handleIdChange(selected: HTMLElement, currentId: number) {
    const lastElementId = Number(
      document.querySelectorAll(`[data-img-id]`).length - 1
    )
    selected.className = 'o-Carousel__Current'
    const previousId = currentId !== 0 ? currentId - 1 : lastElementId
    changeClassName(previousId, 'o-Carousel__Prev')
    const nextPreviousId = previousId !== 0 ? previousId - 1 : lastElementId
    changeClassName(nextPreviousId, 'o-Carousel__Prev__Second')
    const nextId = currentId !== lastElementId ? currentId + 1 : 0
    changeClassName(nextId, 'o-Carousel__Next')
    const nextSecondId = nextId !== lastElementId ? nextId + 1 : 0
    changeClassName(nextSecondId, 'o-Carousel__Next__Second')
  }
  const clickHandler = (selected: HTMLElement) => {
    const currentId = Number(selected.dataset.imgId)
    handleIdChange(selected, currentId)
  }

  parentNodeMobileAppCarousel?.addEventListener('click', (event: Event) => {
    const clickedElement = event.target

    if (clickedElement instanceof Element) {
      if (clickedElement.closest('.o-Carousel__Image')) {
        const selected = clickedElement.parentElement
        if (selected) {
          clickHandler(selected)
        }
      }

      if (clickedElement.closest('.o-Carousel__Prev__Button')) {
        const previousElement = document.querySelector<HTMLElement>(
          '.o-Carousel__Current'
        )?.previousElementSibling
        if (
          previousElement instanceof HTMLElement &&
          previousElement.tagName === 'DIV'
        ) {
          clickHandler(previousElement)
        } else {
          const lastElement =
            document.querySelector<HTMLElement>('[data-img-id="4"]')
          if (lastElement) {
            clickHandler(lastElement)
          }
        }
      }
      if (clickedElement.closest('.o-Carousel__Next__Button')) {
        const nextElement = document.querySelector<HTMLElement>(
          '.o-Carousel__Current'
        )?.nextElementSibling
        if (nextElement && nextElement instanceof HTMLElement) {
          clickHandler(nextElement)
        } else {
          const firstElement =
            document.querySelector<HTMLElement>('[data-img-id="0"]')
          if (firstElement) {
            clickHandler(firstElement)
          }
        }
      }
    }
  })
}
